import {
  Box,
  Grid,
  MenuItem,
  TextField,
  Card,
  Typography,
  Button,
  Backdrop,
  Snackbar,
  Alert,
  CircularProgress,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  List,
  ListItem,
  ListItemText,
  IconButton,
  Icon,
  Divider,
  Paper,
  Container,
} from "@mui/material";
import { useEffect, useState } from "react";
import DashboardLayout from "../components/dashboard_layout";
import axios from "../../axios";
import AppLogo from "../../app/assets/logo.png";
import { useNavigate } from "react-router-dom";

function ApplyPage() {
  const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [categories, setCategories] = useState([]);
  const [preRoads, setPreRoads] = useState([]);
  const [roads, setRoads] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedRoad, setSelectedRoad] = useState(null);
  const [selectedQty, setSelectedQty] = useState(null);

  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [applicationItems, setApplicationItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`practitioners/applications/init.json`)
        .then((result) => {
          console.log(result.data.data);
          setShowLoading(false);
          if (result.data.status === "success") {
            setCategories(result.data.data.categories);
            setPreRoads(result.data.data.roads);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred.");
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (selectedCategory === null) {
      return;
    }

    let tmp = [];
    preRoads.every(function (rd) {
      if (rd.category === selectedCategory) {
        tmp.push(rd);
      }
      return true;
    });

    setRoads(tmp);
  }, [selectedCategory]);

  function removeRoadItem(indx) {
    const tApIts = applicationItems;
    tApIts.splice(indx, 1);
    setApplicationItems(tApIts);

    setSeverity("warning");
    setErrMsg("Road entry has been removed.");
    setOpen(true);
  }

  async function apply() {
    if (applicationItems.length <= 0) {
      setSeverity("error");
      setErrMsg("Please add at least one road to your application.");
      setOpen(true);
      return false;
    }

    const roadsFinal = [];
    applicationItems.every(function (itm) {
      roadsFinal.push({
        reference: itm.reference,
        quantity: itm.quantity,
      });
      return true;
    });

    setShowLoading(true);
    const json = { roads: roadsFinal };
    await axios
      .post("practitioners/applications/apply.json", json)
      .then((result) => {
        setShowLoading(false);
        if (result.data.status === "success") {
          navigate("/applications");
          return;
        } else {
          setSeverity("error");
          setErrMsg(result.data.data.message);
          setOpen(true);
        }
      })
      .catch(() => {
        setShowLoading(false);
        setSeverity("error");
        setErrMsg("An error occurred.");
        setOpen(true);
      });
  }

  return (
    <DashboardLayout>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openAddDialog} fullWidth maxWidth="xs">
        <DialogTitle>
          <Typography variant="h6">Add Road</Typography>
        </DialogTitle>
        <DialogContent>
          <Box>
            <Box mt={3} mb={5}>
              <TextField
                label="Category"
                fullWidth
                select
                onChange={(e) => {
                  setSelectedCategory(e.target.value);
                }}
              >
                {categories.map((category) => (
                  <MenuItem
                    name={category.reference}
                    value={category.reference}
                  >
                    {category.title}
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            <Box mb={5}>
              <TextField
                label="Available Roads"
                fullWidth
                select
                onChange={(e) => setSelectedRoad(e.target.value)}
              >
                {roads.map((road) => (
                  <MenuItem name={road.reference} value={road.reference}>
                    {/* {road.title} - [Poles Available: {road.quantity}] */}
                    <ListItem>
                      <ListItemText
                        primary={road.title}
                        secondary={
                          <Typography fontSize={14} fontWeight={350}>
                            Location: {road.location}
                            <br />
                            Poles Available: {road.quantity}
                          </Typography>
                        }
                      />
                    </ListItem>
                  </MenuItem>
                ))}
              </TextField>
            </Box>
            {/* <Box px={1} mb={5}>
                    <Typography fontSize={12}>Available Poles: 312</Typography>
                  </Box> */}
            <Box mb={10}>
              <TextField
                onChange={(e) => setSelectedQty(parseInt(e.target.value, 10))}
                fullWidth
                label="Pole Quantity Required"
                type="number"
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Box p={1}>
            <Button onClick={() => setOpenAddDialog(false)}>Cancel</Button>
            &nbsp; &nbsp;
            <Button
              variant="contained"
              onClick={() => {
                if (selectedCategory === null) {
                  return;
                }

                if (selectedRoad === null) {
                  return;
                }

                if (selectedQty === null) {
                  return;
                }

                let tmpCat = {};
                categories.every(function (cat) {
                  if (cat.reference === selectedCategory) {
                    tmpCat = cat;
                    return false;
                  }
                  return true;
                });

                let tmpRd = {};
                preRoads.every(function (rd) {
                  if (rd.reference === selectedRoad) {
                    tmpRd = rd;
                    return false;
                  }
                  return true;
                });

                let dt = {
                  reference: tmpRd.reference,
                  title: tmpRd.title,
                  category: tmpCat.title,
                  quantity: selectedQty,
                };

                if (tmpRd.quantity < selectedQty) {
                  setSeverity("error");
                  setErrMsg("Quantity exceeds number of available poles");
                  setOpen(true);
                  return false;
                }

                let tmps = applicationItems;
                tmps.unshift(dt);
                setApplicationItems(tmps);
                setOpenAddDialog(false);
              }}
            >
              Add Road
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
      <Container>
        <Box p={0}>
          <Box mb={3}>
            <Button
              startIcon={<Icon>chevron_left</Icon>}
              onClick={() => navigate("/dashboard")}
            >
              Back
            </Button>
          </Box>
          <Box>
            <Box
              sx={{
                mt: {
                  xs: 5,
                  md: 1,
                },
              }}
            >
              <Card elevation={2} sx={{ width: "100%" }}>
                <Box p={2}>
                  <Box
                    display="flex"
                    flexDirection="row"
                    justifyContent="space-between"
                  >
                    <Box>
                      <Typography variant="h6">
                        Digital Application Form
                      </Typography>
                    </Box>
                    <Box>
                      <IconButton
                        variant="outlined"
                        color="primary"
                        onClick={() => setOpenAddDialog(true)}
                      >
                        <Icon>add</Icon>
                      </IconButton>
                    </Box>
                  </Box>
                  <Box>
                    <Divider />
                  </Box>
                  <Box mb={10}>
                    {applicationItems.length > 0 ? (
                      <List>
                        {applicationItems.map((item, idx) => (
                          <>
                            <ListItem
                              secondaryAction={
                                <IconButton
                                  edge="end"
                                  aria-label="delete"
                                  onClick={() => {
                                    if (
                                      window.confirm("Remove road entry?") ===
                                      false
                                    ) {
                                      return;
                                    }

                                    removeRoadItem(idx);
                                  }}
                                >
                                  <Icon>delete</Icon>
                                </IconButton>
                              }
                            >
                              <ListItemText
                                primary={`${idx + 1}. ${item.title}`}
                                secondary={`Category: ${item.category} | Poles: ${item.quantity}`}
                              />
                            </ListItem>
                            <Divider />
                          </>
                        ))}
                      </List>
                    ) : (
                      <Box px={1} mt={2}>
                        <Typography variant="caption" fontWeight={200}>
                          Add roads to your application, click the "+" icon to
                          begin.
                        </Typography>
                      </Box>
                    )}
                  </Box>
                  <Box mb={1} align="right">
                    <Button
                      size="large"
                      color="primary"
                      variant="contained"
                      onClick={() => {
                        apply();
                      }}
                    >
                      Submit Application
                    </Button>
                  </Box>
                </Box>
              </Card>
            </Box>
          </Box>
        </Box>
      </Container>
    </DashboardLayout>
  );
}

export default ApplyPage;
